import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, tool }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFDFB]">
        <Loader2 className="w-8 h-8 animate-spin text-[#1F3C88]" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (tool && !user.tools.includes(tool)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
